var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaitingOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 0.916656C11.4121 0.916656 14.5833 4.08858 14.5833 8C14.5833 11.9114 11.4121 15.0833 7.49996 15.0833C3.58784 15.0833 0.416626 11.9114 0.416626 8C0.416626 4.08858 3.58784 0.916656 7.49996 0.916656ZM7.49996 2.09745C4.24517 2.09745 1.59742 4.7452 1.59742 8C1.59742 11.2548 4.24517 13.9025 7.49996 13.9025C10.7548 13.9025 13.4025 11.2548 13.4025 8C13.4025 4.7452 10.7548 2.09745 7.49996 2.09745ZM6.96871 3.74999C7.23753 3.74999 7.45994 3.94998 7.49508 4.20918L7.49996 4.28124V8H9.80205C10.0953 8 10.3333 8.238 10.3333 8.53125C10.3333 8.80006 10.1333 9.02248 9.87409 9.05761L9.80205 9.0625H6.96871C6.6999 9.0625 6.47748 8.86253 6.44235 8.60328L6.43746 8.53125V4.28124C6.43746 3.98799 6.67546 3.74999 6.96871 3.74999Z",
    fill: "#716F73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingOrder);
export default __webpack_public_path__ + "static/media/waiting_order.bc4075a55ef001f3d2e3f82382fe06ab.svg";
export { ForwardRef as ReactComponent };